import * as React from 'react'

import { useMediaQuery } from '@mui/material';

import {HashLink as Link } from "react-router-hash-link";


import { HeaderComponent, HeaderContent, Logo, LogoDiv, MobileDiv, NavItem,  NavMenu, OrcamentoButton } from './styles';

import LogoIcon from '../../../../../assets/images/Logos/bhbus20bg-96x96.png'
import SideBarLP from '../../../sidebarlp';

interface TopHeaderProps {
    reference: any;
    title?: any;
    hide?: boolean;
}

const TopHeader: React.FC<TopHeaderProps> = ({ reference, title }) => {
    const matches = useMediaQuery('(max-width:1100px)');

    const dataHeader = [
        {name:"Início", value: "homelp", link: '/midiaembh'},
        {name:"Sobre", value: "sobrelp", link: '#sobrelp'},
        {name:"Produtos", value: "produtolp", link: '#produtolp'},
    ]

    return (
        <HeaderComponent>
            {matches ? (
                 <MobileDiv>
                    <LogoDiv>
                        <Logo src={LogoIcon}/>
                    </LogoDiv>
                    <SideBarLP nome={dataHeader}/>
                </MobileDiv>
            ) : (
                <HeaderContent>
                    <LogoDiv>
                        <Logo src={LogoIcon}/>
                    </LogoDiv>
                    <NavMenu>
                        {dataHeader.map((item, index) => (
                            <React.Fragment key={item.value}>
                                <Link to={item?.link}>
                                    <NavItem
                                        key={item.value}
                                        active={item.value === 'home'}
                                        
                                    >
                                        {item.name}
                                    </NavItem>
                                </Link>
                            </React.Fragment>
                        ))}
                        <OrcamentoButton
                            href="https://api.whatsapp.com/send?phone=553131983024595&text=Ol%C3%A1,%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20BHBus%20M%C3%ADdia%20"
                            target='_blank'
                        >
                            Fale Conosco
                        </OrcamentoButton>
                        {/* <SearchDiv>
                            <Search data={contentData} />
                        </SearchDiv> */}
                    </NavMenu>
                </HeaderContent>
            )}
        </HeaderComponent>
    );
}

export { TopHeader }